import { STRINGS } from '../i18n';
import type { ExpenseCategory, Lang } from '../types';

/** id, icon — the translations come from the bundled STRINGS below. */
const SEED: [string, string][] = [
  ['salary', 'salary'],
  ['rent', 'rent'],
  ['material', 'material'],
  ['vegetables', 'vegetables'],
  ['utilities', 'utilities'],
  ['maintenance', 'maintenance'],
  ['other', 'wallet'],
];

/**
 * The spending heads that ship inside the app.
 *
 * A fallback, not a duplicate — exactly like FALLBACK_CATEGORIES. The live list
 * comes from the database and is cached on the device; this is what a brand-new
 * install shows before its first sync, and what the owner sees if the cache is
 * wiped while they are offline. The ids here match the slugs the migration
 * seeds, so a head edited in the app lines up with the row the database made.
 */
export const FALLBACK_EXPENSE_CATEGORIES: ExpenseCategory[] = SEED.map(
  ([id, icon], i) => ({
    id,
    name: STRINGS.en[('exp_' + id) as keyof typeof STRINGS.en] ?? id,
    nameHi: STRINGS.hi[('exp_' + id) as keyof typeof STRINGS.hi] ?? '',
    nameGu: STRINGS.gu[('exp_' + id) as keyof typeof STRINGS.gu] ?? '',
    icon,
    sortOrder: i * 10,
    active: true,
  }),
);

/** Name in the requested language, falling back to English. */
export function expenseCategoryName(
  cat: ExpenseCategory | undefined,
  lang: Lang,
): string {
  if (!cat) return '';
  if (lang === 'hi' && cat.nameHi) return cat.nameHi;
  if (lang === 'gu' && cat.nameGu) return cat.nameGu;
  return cat.name;
}

export function sortExpenseCategories(list: ExpenseCategory[]): ExpenseCategory[] {
  return [...list].sort(
    (a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name),
  );
}
